import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NavigationService } from 'src/app/core/services';

/**
 * For breadcrumbs
 */
@UntilDestroy()
@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html'
})
export class BreadcrumbsComponent implements OnDestroy {
  public currentBreadcrumbs: any;

  constructor(public router: Router, private navigationService: NavigationService) {
    this.navigationService.castCurrentBreadcrumbs
      .pipe(untilDestroyed(this))
      .subscribe(data => this.currentBreadcrumbs = data);
  }

  public ngOnDestroy(): void { }

  /**
   * Navigates to the link
   */
  public navigateTo(breadcrumb: any): void {
    this.router.navigate([breadcrumb.link]);
  }

}
